import { colorConstants } from 'config/colorConstants';
import React from 'react';
import { chooseIconIndex } from 'utils/helperMethods';
const iconIndex = chooseIconIndex();

const Neutral = ({
    stroke = colorConstants.limeGreen,
    width = 9,
    height = 8,
}: {
    stroke?: string;
    width?: number;
    height?: number;
}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 11 2" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.726807" width="10" height="2" rx="1" fill="#E8A122" />
        </svg>
    );
};

export default Neutral;
